/**
 * @file router-site-view.tsx
 * @description Маршруты «Сайт» (phase19.16 Р1-6а): конструктор сайта —
 * одно окно для страниц, блоков и вида сайта (`site/builder`) под каркасом
 * `SiteViewLayout` (черновик вида сайта, общие окна публикации, «Что
 * изменено», отмены и предпросмотра). Прежние экраны «Оформление», «Шапка
 * и подвал», «Меню», «Настройки сайта», «SEO», «Лента блога», «История»
 * перенаправляются в конструктор (минимум один выпуск).
 *
 * Права — по частям (`SITE_VIEW_PART_RIGHTS`): каркас пускает сотрудника с
 * правом правки хотя бы одной части, раздел без права объясняет, кто его
 * меняет.
 *
 * Р3в (v0.19.64, SB145): «Сайт → SEO» (`site/seo`) — отдельная страница вне
 * каркаса вида сайта (черновик ей не нужен): право контента или настроек.
 * Прежний адрес `site/seo` вёл в панель «SEO» конструктора — теперь это сам
 * раздел, поэтому из старых адресов он убран.
 */

import { Navigate, type RouteObject } from "react-router";

import { RequirePermission } from "./components/guards/RequirePermission";
import { LegacySiteRedirect } from "./components/site-builder/LegacySiteRedirect";
import { LEGACY_SITE_ROUTES } from "./lib/site-builder/selection";
import { SiteSeoPage } from "./pages/shop/site/SiteSeoPage";
import { SiteBuilderPage } from "./pages/shop/site-view/SiteBuilderPage";
import { SiteViewLayout } from "./pages/shop/site-view/SiteViewLayout";

/** «Сайт → SEO» — дочерний маршрут `ShopLayout`, вне каркаса вида сайта. */
export const siteSeoRoute: RouteObject = {
  path: "site/seo",
  element: <RequirePermission permissions={[]} anyOf={["SHOP_MANAGE_CONTENT", "SHOP_MANAGE_SETTINGS"]} />,
  children: [{ index: true, element: <SiteSeoPage /> }],
};

/** Каркас вида сайта и конструктор — дочерний маршрут `ShopLayout`. */
export const siteViewRoute: RouteObject = {
  path: "site",
  element: <SiteViewLayout />,
  children: [
    { index: true, element: <Navigate to="builder" replace /> },
    { path: "builder", element: <SiteBuilderPage /> },
    ...Object.keys(LEGACY_SITE_ROUTES).map((route) => ({ path: route, element: <LegacySiteRedirect route={route} /> })),
  ],
};
